module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/saas-1-d7bac00c358ac17f03815501cdc5fc41.jpg";